export class TradeApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getTradesList(params) {
    return this.#http.get('/api/trades', { params });
  }

  async getTrade(id) {
    return this.#http.get(`/api/trades/${id}`);
  }

  async createTrade(body) {
    return this.#http.post('/api/trades', body);
  }

  async updateTrade({ id, ...body }) {
    return this.#http.put(`/api/trades/${id}`, body);
  }

  async deleteTrade(id) {
    return this.#http.delete(`/api/trades/${id}`);
  }

  async updateTradeStatus(id, status) {
    return this.#http.put(`/api/trades/${id}/status`, { status });
  }
}
